import { orderBy } from 'lodash';

export const filterAndSortExpertFields = ({
  expertFields = [],
  expertFieldGroups = [],
  getFieldValue,
  isDrawer = false
}) => {
  let fields = [...expertFields];

  if (expertFieldGroups?.length > 0) {
    fields = fields.filter((field) => {
      const group = expertFieldGroups.find((expertFieldGroup) => expertFieldGroup.codes.includes(field.code));
      if (group) {
        return Object.entries(group.conditions).every(([conditionKey, expectedValue]) => {
          const conditionField = expertFields.find((input) => input.code === conditionKey);
          if (!conditionField) return false;

          const currentValue = getFieldValue ? getFieldValue(conditionField.id) : conditionField.result;
          return currentValue === expectedValue;
        });
      }
      return true;
    });
  }

  if (isDrawer) {
    fields = fields.filter((field) => !field.code?.startsWith('ESTADO_'));
  }

  return orderBy(fields, (field) => field.order, ['asc']);
};
